import { Cosmograph } from "@cosmograph/react";
import { useContext } from "react";
import { GraphContext } from "./data";
import { NODE_SOURCE_LIST_NAME } from "./model";

export function CosmoComponent() {
  const { setClusterData, setNodeData, sharedData, setSharedData } = useContext(GraphContext);
  const onClick = (d: any) => {
    // console.log("click", d);
    if (!d) {
      setClusterData(d);
      setNodeData(d);
      setSharedData({
        source: "",
        subType: sharedData.subType,
      });
      return;
    }

    setNodeData(d);
    if (d["cluster_no"] && d["cluster_no"] !== "0") {
      setClusterData(d);
      setSharedData({
        source: d["id"],
        subType: "",
      });
    }
  };

  const onLabelClick = (d: any) => {
    // console.log("label", d);
    onClick(d);
  };

  return (
    <Cosmograph
      nodeColor={(d: any) => {
        // console.log('node:', d);
        const transparent =
          !sharedData.source && !sharedData.subType && !sharedData.rangeField
            ? "a0"
            : (d[NODE_SOURCE_LIST_NAME] &&
                d[NODE_SOURCE_LIST_NAME].includes(sharedData.source)) ||
              (sharedData.subType && d["subtype"] === sharedData.subType) ||
              (sharedData.rangeField &&
                d[sharedData.rangeField] >= sharedData.rangeMin! &&
                d[sharedData.rangeField] <= sharedData.rangeMax!)
            ? "f0"
            : "30";
        return d["nodecolor"] + transparent;
      }}
      nodeSize={(d: any) => {
        const sizeScale =
          (sharedData.source &&
            d[NODE_SOURCE_LIST_NAME].includes(sharedData.source)) ||
            (sharedData.subType && d["subtype"] === sharedData.subType) ||
            (sharedData.rangeField &&
              d[sharedData.rangeField] >= sharedData.rangeMin! &&
              d[sharedData.rangeField] <= sharedData.rangeMax!)
            ? 2
            : 1;
        return d["nodesize"] * sizeScale;
      }}
      linkColor={(d: any) => {
        // console.log("link:", d);
        const transparent =
          !sharedData.source
            ? "a0"
            : d["source"] === sharedData.source
            ? "f0"
            : "30";
        return d["linkcolor"] + transparent;
      }}
      linkWidth={(d: any) => {
        const size = d["source"] === sharedData.source ? 2 : 1;
        return size;
      }}
      disableSimulation={false}
      fitViewOnInit={true}
      // linkVisibilityDistanceRange={(d: any) => [d.alntmscore as number, 1000]}
      // spaceSize={4000}
      linkArrows={false}
      simulationGravity={0.25}
      simulationRepulsion={1}
      simulationRepulsionTheta={1.92}
      simulationLinkSpring={1}
      simulationLinkDistance={10}
      simulationFriction={0.5}
      // simulationDecay={10}
      // simulationLinkSpring={0.5}
      // simulationCenter={4}
      // simulationRepulsionQuadtreeLevels={5}
      // showDynamicLabels={true}
      // renderLinks={true}
      onLabelClick={onLabelClick}
      onClick={onClick}
    />
  );
}
